// src/app/(dashboard)/meter/components/Badge.tsx
import React from "react";
import type { MeterStatus } from "../utils/meterStatus";

const STATUS_CONFIG: Record<
  MeterStatus,
  { bg: string; text: string; ring: string }
> = {
  online: {
    bg: "bg-emerald-50 dark:bg-emerald-950/40",
    text: "text-emerald-800 dark:text-emerald-200",
    ring: "ring-emerald-200 dark:ring-emerald-900",
  },
  offline: {
    bg: "bg-rose-50 dark:bg-rose-950/40",
    text: "text-rose-800 dark:text-rose-200",
    ring: "ring-rose-200 dark:ring-rose-900",
  },
  unknown: {
    bg: "bg-slate-50 dark:bg-slate-950/40",
    text: "text-slate-800 dark:text-slate-200",
    ring: "ring-slate-200 dark:ring-slate-900",
  },
};

const STATUS_LABEL: Record<MeterStatus, string> = {
  online: "ออนไลน์",
  offline: "ออฟไลน์",
  unknown: "ไม่ทราบ",
};

export function Badge({ status }: { status: MeterStatus }) {
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={[
        "inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold",
        "ring-1 ring-inset",
        config.bg,
        config.text,
        config.ring,
      ].join(" ")}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}

const DOT_COLOR: Record<MeterStatus, string> = {
  online: "bg-emerald-500 dark:bg-emerald-400",
  offline: "bg-rose-500 dark:bg-rose-400",
  unknown: "bg-slate-400 dark:bg-slate-500",
};

export function StatusDot({ status }: { status: MeterStatus }) {
  return (
    <span
      title={STATUS_LABEL[status]}
      aria-label={STATUS_LABEL[status]}
      className={["inline-block h-2.5 w-2.5 rounded-full", DOT_COLOR[status]].join(" ")}
    />
  );
}
